<div class="font-10 cout-portion-pondere" *ngIf="displayCoutsDetails"  [style.color]="menuCompo.udpPdMarge >= 0 ? 'var(--success-color)' : 'var(--error-color)'" title="Marge" >
 {{menuCompo.udpPdMarge == null ? ' - ' : menuCompo.udpPdMarge + ' %' }}
</div>
